import { gql } from '@apollo/client';
import { MONEY_OBJECT } from './moneyObject';

export const OFFER_DETAIL_FIELDS = gql`
    fragment OfferDetailFields on Offer {
        id
        offerNumber
        offerDate
        project
        projectNumber
        bindingPeriod
        orderType
        offerText
        purchaser
        modificationRule
        customerId
        contactPerson
        priceDeliveryNote
        singleInvoice
        costCenter
        shippingInstructions
        desiredDeliveryDate
        displayShippingMethod
        priceBindingPeriod
        shippingAddress {
            id
            externalId
            primaryAddress
            name
            streetName
            city
            postalCode
            country
            addressExtraLineOne
            addressExtraLineTwo
            addressExtraLineThree
        }
        offerReferenceShippingAddress {
            id
            externalId
            primaryAddress
            name
            streetName
            city
            postalCode
            country
            addressExtraLineOne
            addressExtraLineTwo
            addressExtraLineThree
        }
        priceObject {
            value {
                ...MoneyObjectFields
            }
            valueDiscountSum {
                ...MoneyObjectFields
            }
            valueMaterialPriceSurchargesSum {
                ...MoneyObjectFields
            }
            valueSurchargeCutSum {
                ...MoneyObjectFields
            }
            valueSurchargesSum {
                ...MoneyObjectFields
            }
            valueWithoutAdditional {
                ...MoneyObjectFields
            }
        }
        shippingInfo {
            shippingMethod {
                id
                key
            }
        }
        offerPositionsGroups {
            name
            groupType
            groupTotalPrice {
                ...MoneyObjectFields
            }
            groupBasePrice {
                ...MoneyObjectFields
            }
            groupTotalSurcharges {
                ...MoneyObjectFields
            }
            groupTotalDiscount {
                ...MoneyObjectFields
            }
            offerPositions {
                id
                isSelected
                fixPosNumber
                posNumber
                sku
                ean
                name
                dispo
                positionText
                quantity
                boughtPositions
                totalAvailableQuantity
                priceObject {
                    surchargeCut {
                        value {
                            ...MoneyObjectFields
                        }
                    }
                    totalSurchargeValue {
                        ...MoneyObjectFields
                    }
                    vats {
                        value {
                            ...MoneyObjectFields
                        }
                    }
                    productPriceSum {
                        ...MoneyObjectFields
                    }
                    value {
                        ...MoneyObjectFields
                    }
                    basePrice {
                        ...MoneyObjectFields
                    }
                    priceObject {
                        priceReference
                    }
                    materialPriceSurcharges {
                        value {
                            ...MoneyObjectFields
                        }
                    }
                    discountSum {
                        ...MoneyObjectFields
                    }
                }
                salesUnit
                quantityUnit
                imageThumbnailUrl
                isSelected
                isAlternativePosition
                isOptionalPosition
                positionType
                isPackageItem
                isDiversarticle
                bindingPeriod
                projectPosNumber
                noShopOrder
                hidePrice
                title
            }
        }
    }
    ${MONEY_OBJECT}
`;
